<template>
  <!-- 导航部分 -->
  <nav class="navbar navbar-expand-lg navbar-light bg">
    <img class="navbar-brand" src="../../assets/logo.png" />
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavAltMarkup"
      aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse position" id="navbarNavAltMarkup">
      <div class="navbar-nav">
        <router-link to="/" class="nav-item nav-link color" :class="{ active: active === 'Index' }">首页
          <span class="sr-only">(current)</span>
        </router-link>
        <div class="dropdown show">
          <a class="btn btn-link dropdown-toggle nav-item nav-link color"
            :class="{ active: active === 'Product' || active === 'SelfPrinting' || active === 'SharePrinting' }" href="#" role="button"
            id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            产品介绍
          </a>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
            <router-link to="/SelfPrinting" class="dropdown-item" href="#">自助打印系统</router-link>
            <router-link to="/CopierSelfprinting" class="dropdown-item" href="#">复印机自助打印系统</router-link>
            <router-link to="/SharePrinting" class="dropdown-item" href="#">共享打印系统</router-link>
          </div>
        </div>

        <div class="dropdown show">
          <a class="btn btn-link dropdown-toggle nav-item nav-link color" :class="{ active: active.includes('Solution') }"
            href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true"
            aria-expanded="false">
            解决方案        
          </a>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
            <router-link to="/PrintSolution" class="dropdown-item" href="#">图文快印解决方案</router-link>
            <router-link to="/OfficeSolution" class="dropdown-item" href="#">企业办公解决方案</router-link>
            <router-link to="/ShareSolution" class="dropdown-item" href="#">共享打印解决方案</router-link>
          </div>
        </div>

        <router-link to="/DownLoad" class="nav-item nav-link color"
          :class="{ active: active === 'DownLoad' }">软件下载</router-link>
        <router-link to="/Join" class="nav-item nav-link color" :class="{ active: active === 'Join' }">合作加盟</router-link>
        <router-link to="/ServiceSupport" class="nav-item nav-link color"
          :class="{ active: active === 'ServiceSupport' }">服务支持</router-link>
        <router-link to="/AboutUs" class="nav-item nav-link color"
          :class="{ active: active === 'AboutUs' }">关于我们</router-link>
        <a href="#" class="nav-item nav-link color">
          <span class="fa fa-phone"></span> 400-805-6601</a>
        <a href="https://kyweb.yindd.cn/#/" target="_blank" class="nav-item nav-link color">登录打印</a>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  data() {
    return {
      active: "Index",
    };
  },
  mounted() {
    this.$route.name ? (this.active = this.$route.name) : "";
  },
  watch: {
    $route: function (val) {
      this.active = this.$route.name;
      console.log(this.active);
    },
  },
};
</script>

<style lang="stylus" scoped>
.position {
  justify-content: flex-end;
}

.dropdown-item {
  padding: 0.75rem 1.5rem !important;
}

.a-btn {
  border: 1px solid #fff;
  border-radius: 4px;
}

.bg {
  width: 100%;
  z-index: 1000;
  position: absolute;
  top: 0;
  left: 0;
  -webkit-transition: background 300ms cubic-bezier(0, 0, 0.2, 1) 150ms;
  -moz-transition: background 300ms cubic-bezier(0, 0, 0.2, 1) 150ms;
  -o-transition: background 300ms cubic-bezier(0, 0, 0.2, 1) 150ms;
  transition: background 300ms cubic-bezier(0, 0, 0.2, 1) 150ms;
}

.bg:hover {
  -webkit-transition: background 300ms cubic-bezier(0, 0, 0.2, 1) 0ms;
  -moz-transition: background 300ms cubic-bezier(0, 0, 0.2, 1) 0ms;
  -o-transition: background 300ms cubic-bezier(0, 0, 0.2, 1) 0ms;
  transition: background 300ms cubic-bezier(0, 0, 0.2, 1) 0ms;
}

.color {
  color: #fff !important;
  margin-left: 30px;
  text-align: center;
  position: relative;
  outline: 0;
}

.color:hover::before {
  display: block;
  height: 2px;
  background: #00C1DE;
  width: 100%;
  content: '';
  bottom: 0;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

.color.active::before {
  display: block;
  height: 2px;
  background: #00C1DE;
  width: 100%;
  content: '';
  bottom: 0;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
</style>



// WEBPACK FOOTER //
// src/components/comm/header.vue